import type { SelectOption } from '@/shared';

export const selectOption = (
  options: SelectOption[],
  value?: SelectOption['value']
): SelectOption | undefined => {
  if (value === undefined) {
    return undefined;
  }

  const filtered = options.filter((o) => o.value === value);

  if (filtered.length) {
    return filtered[0];
  }
  return undefined;
};
